<template>
  <div class="main-content">
    <div>
      <pulse-loader :loading="loading" :color="color" class="text-center"/>
    </div>

    <customModal v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="resetSelectedRunner"
                 :modalData="modalData"></customModal>

    <div class="row" v-if="$currentRole != 'storeKeeper'">
      <div class="col-md-6">
        <div v-if="runnersWithOutPack" class="card">
          <div class="card-body">
            <allRunners ref="runnersWoPacks" v-if="runnersWithOutPack" :users="runnersWithOutPack" :selectAll="true"
                        type="woPacks"/>
            <div v-if="runnersWithOutPack.length">
              <button @click="setBackPacks" class="btn btn-success">Выдать рюкзак(и)</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div v-if="runnersWithPack" class="card">
          <div class="card-body">
            <allRunners v-if="runnersWithPack" :users="runnersWithPack" type="wPacks"/>
            <div v-if="runnersWithPack.length">
              <button @click="resetAllPacks" class="btn btn-warning">Обнулить рюкзаки всех курьеров</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row" v-if="runnersWithPack && runnersWithPack.length">
        <div class="col-md-12" v-for="(runner, index) in runnersWithPack" :key="index">
          <backPack :runner="runner"
                    :openModal="openModal"
                    :ordersData="ordersData"
                    :showBackPackOrders="showBackPackOrders"
                    :realisedDrugs="realisedDrugs[runner.id]"/>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body text-center">
              <h5>Активных рюкзаков нет</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <back-to-top bottom="50px" right="50px">
      <button type="button" class="btn btn-info btn-to-top"><i class="icon-fa icon-fa-chevron-up"></i></button>
    </back-to-top>
  </div>
</template>

<script>
import api from '@/api'
import allRunners from '@/components/runners/allRunners'
import backPack from '@/components/runners/backPack'
import BackToTop from 'vue-backtotop'
import customModal from '@/components/modals/customModal'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  data() {
    return {
      ordersData: {},
      showBackPackOrders: true,
      runnersWithPack: null,
      runnersWithOutPack: null,
      realisedDrugs: null,
      Toast: this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }),
      modalData: null,
      loading: true,
      color: '#007dcc',
    }
  },
  components: {
    allRunners,
    backPack,
    BackToTop,
    customModal,
    PulseLoader
  },
  mounted() {
    this.getRunners()
  },
  methods: {
    async getRunners() {
      let {data} = await api.store('/runners/getRunners', {});
      this.runnersWithPack = data.runners_wpack;
      this.runnersWithOutPack = data.runners_wopack;
      this.realisedDrugs = data.realised_drugs;
      this.ordersData = data.ordersData;
      this.loading = false;
    },
    resetAllPacks() {
      let runners = this.runnersWithPack.map((r) => {
        return r.id
      });
      this.modalData = {
        runnerId: null,
        runners: runners,
        header: 'Вы уверены?',
        body: 'Хотите обнулить все активные рюкзаки?',
        acceptBtnText: 'Да',
        cancelBtnText: 'Нет'
      };
    },
    async resetSelectedRunner() {
      let {data} = await api.store('/runners/resetBackPack', {
        runner_id: this.modalData.runnerId,
        runners: this.modalData.runners || []
      });
      this.runnersWithOutPack = null;
      this.runnersWithPack = null;
      this.loading = true;
      this.getRunners();
      // console.log(this.modalData.runnerId);
      // if (this.modalData.runnerId) {
      //     // delete this.runnersWithPack[this.modalData.runnerId];
      //     this.runnersWithPack = this.runnersWithPack.filter(r => r.id != this.modalData.runnerId);
      //     // console.log(this.runnersWithPack);
      //     // this.originalSubOrders[key] = [...this.originalSubOrders[key]];
      // }
      this.onModalClose();
    },
    onModalClose() {
      this.modalData = null;
    },
    openModal(runner) {
      this.modalData = {
        runnerId: runner.id,
        header: 'Вы уверены?',
        body: 'Хотите обнулить рюкзак<br><b>' + runner.name + '</b>?',
        acceptBtnText: 'Да',
        cancelBtnText: 'Нет'
      };
    },
    async setBackPacks() {
      let selected = Object.keys(this.$refs.runnersWoPacks.selected_runners).filter(r => this.$refs.runnersWoPacks.selected_runners[r]);
      if (!selected.length) {
        toastr["warning"]("Выберите курьеров");
        return;
      }
      let {data} = await api.store('/runners/setBackpack', {
        runner_id: null,
        runners: selected
      })
      if (data.success) {
        await this.getRunners();
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        })
      } else {
        this.Toast.fire({
          type: 'warning',
          title: 'Ошибка ' + data.message
        })
      }
    }
  }
}
</script>
